const getHeaderBgSetter = () => {
    const doc = document.documentElement;

    return (color: string) => {
        doc.style.setProperty('--color-component-header-bg', color);
    };
};

export const setHeaderBg = getHeaderBgSetter();

const getHeaderLinkTextSetter = () => {
    const doc = document.documentElement;

    return (color: string) => {
        doc.style.setProperty('--color-component-header-text', color);
    };
};

export const setHeaderLinkTextColor = getHeaderLinkTextSetter();

const getHeaderContrastTextSetter = () => {
    const doc = document.documentElement;

    return (color: string) => {
        doc.style.setProperty('--color-component-header-contrast-text', color);
    };
};

export const setHeaderContrastTextColor = getHeaderContrastTextSetter();
